import { render, staticRenderFns } from "./subnav.vue?vue&type=template&id=5989a35a&"
import script from "./subnav.vue?vue&type=script&lang=js&"
export * from "./subnav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports